import { useMemo } from 'react';
import type { TextBlock as TextBlockT } from '@aibify/core';
import { renderMarkdown } from './markdown.ts';
import { plainDash } from './format.ts';

export function TextBlock({ block }: { block: TextBlockT }) {
  const html = useMemo(() => renderMarkdown(plainDash(block.markdown)), [block.markdown]);
  return (
    <section className="ab-block" data-block-type="text" data-block-id={block.id}>
      {block.titleHe && (
        <header className="ab-block-head">
          <h3>{plainDash(block.titleHe)}</h3>
        </header>
      )}
      {/* מסונן ב-renderMarkdown (marked + DOMPurify, רשימת תגיות סגורה) */}
      <div className="ab-md" dangerouslySetInnerHTML={{ __html: html }} />
    </section>
  );
}
